/**
 * 项目配置列表
 */
const product = [
    {
        "id": 1,
        "title": "ClashBox",
        "intro": "ClashBox是首个基于Navigation框架的HarmonyOS NEXT平台的代理软件，使用改版的Mihomo(ClashMeta)内核。",
        "thumb": `${process.env.PUBLIC_URL}/images/project/icon-ClashBox.png`,
        "link": "https://github.com/xiaobaigroup/ClashBox",
        "time": "2025.07.16"
    },
    {
        "id": 2,
        "title": "HarmonyOS Haps",
        "intro": "鸿蒙Next HAP安装包合集仓库！本仓库汇集了各类适用于鸿蒙Next系统的HAP安装包，旨在为用户提供便捷的应用下载和更新资源。",
        "thumb": "https://camo.githubusercontent.com/dee0edf7d47bcbd810b2a3708466017b0782d9cb35e0f3eaec7e683841f1d5fb/68747470733a2f2f7777772e6861726d6f6e796f732e636f6d2f7265736f757263652f696d6167652f72656c65617365322f686f6d652f6861726d6f6e794f535f6c6f676f2e706e67",
        "link": "https://github.com/Zitann/HarmonyOS-Haps",
        "time": "2025.09.14"
    },
    {
        "id": 3,
        "title": "HMOS-AppBundleNameForShared",
        "intro": "专为 HarmonyOS 应用，从华为应用商城分享链接中提取应用包名而设计。",
        "thumb": `${process.env.PUBLIC_URL}/images/project/icon-HMOS-AppBundleNameForShared.png`,
        "link": "https://github.com/SummerKaze/HMOS-AppBundleNameForShared",
        "time": "2025.6.22"
    },
    {
        "id": 4,
        "title": "AnimeZ",
        "intro": "OpenHarmony开源看动漫应用。__数据均来源于网络，仅供学习交流!__",
        "thumb": `${process.env.PUBLIC_URL}/images/project/icon-AnimeZ.png`,
        "link": "https://github.com/XHXYT/AnimeZ",
        "time": "2025.10.02"
    }
]

export default product